<template>
    <v-lazy><div class="section fade-in">
      <v-container class="px-10" fluid>
      <v-row justify="center">
          <v-col cols="12" md="7">
          <v-img
          src="../assets/img/language.png"
          class="mx-auto"
          max-width="800"
          contain/>
        </v-col>
        <v-col md="4" cols="12">
          <h2 class="section__header-title">Multi-lingual Messaging</h2>
          <h2 class="text-subtitle-1 mb-15">Supercharge your team with AI support on SMS, Web and Voice channels</h2>
              <v-row>
                  <v-col>
                      <v-sheet class="mb-8 fill-height">
                          Yabbr’s Chat Inbox automatically provides 2-way translation for inbound and outbound messages.
                      </v-sheet>
                  </v-col>
                  <v-col>
                    <v-sheet class="mb-8 fill-height">
                        <b>25% of non-payers</b> report language as the primary barrier to engagement.
                    </v-sheet>
                  </v-col>
                  <v-col>
                    <v-sheet class="mb-8 fill-height">
                          Enable different treatments for different segments of customers, including hardship processes.
                      </v-sheet>
                  </v-col>
              </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div></v-lazy>
</template>
<script>
export default {
    name: 'CollectionsEngagement',
}
</script>

<style lang="scss">


</style>